export interface SubService {
  id: string;
  name: string;
  description: string;
  price: number;
  deliveryTime: string;
}

export interface Service {
  id: string;
  name: string;
  description: string;
  subServices: SubService[];
}

export const services: Service[] = [
  {
    id: 'industrial-training',
    name: 'Industrial Training (IT)',
    description: 'Professional IT reports and presentations for your industrial training program',
    subServices: [
      {
        id: 'it-slide-presentation',
        name: 'IT Slide Presentation',
        description: 'Professional PowerPoint presentation for your IT defense',
        price: 15000,
        deliveryTime: '3-5 days'
      },
      {
        id: 'it-report',
        name: 'IT Report',
        description: 'Comprehensive IT report writing with proper formatting',
        price: 20000,
        deliveryTime: '5-7 days'
      },
      {
        id: 'it-full-package',
        name: 'IT Full Package',
        description: 'Complete package including both slide presentation and report',
        price: 30000,
        deliveryTime: '7-10 days'
      }
    ]
  },
  {
    id: 'seminar',
    name: 'Seminar',
    description: 'Academic seminar papers and presentations',
    subServices: [
      {
        id: 'seminar-slide-presentation',
        name: 'Seminar Slide Presentation',
        description: 'Professional seminar PowerPoint presentation',
        price: 12000,
        deliveryTime: '3-5 days'
      },
      {
        id: 'seminar-report',
        name: 'Seminar Report',
        description: 'Detailed seminar paper writing',
        price: 18000,
        deliveryTime: '5-7 days'
      },
      {
        id: 'seminar-full-package',
        name: 'Seminar Full Package',
        description: 'Complete seminar package with presentation and report',
        price: 25000,
        deliveryTime: '7-10 days'
      }
    ]
  },
  {
    id: 'final-year-project',
    name: 'Final Year Project',
    description: 'Complete final year project documentation and presentation',
    subServices: [
      {
        id: 'fyp-slide-presentation',
        name: 'Final Year Project Slide Presentation',
        description: 'Professional defense presentation for final year project',
        price: 25000,
        deliveryTime: '5-7 days'
      },
      {
        id: 'fyp-report',
        name: 'Final Year Project Report',
        description: 'Complete project report with all chapters',
        price: 40000,
        deliveryTime: '10-14 days'
      },
      {
        id: 'fyp-full-package',
        name: 'Final Year Project Full Package',
        description: 'Complete package including report, presentation, and documentation',
        price: 60000,
        deliveryTime: '14-21 days'
      }
    ]
  }
];

// Helper function to get service by ID
export const getServiceById = (id: string): Service | undefined => {
  return services.find(service => service.id === id);
};

// Helper function to get sub-service by ID
export const getSubServiceById = (serviceId: string, subServiceId: string): SubService | undefined => {
  const service = getServiceById(serviceId);
  return service?.subServices.find(sub => sub.id === subServiceId);
};